import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import PPanel from 'primevue/panel';
import PButton from 'primevue/button';
import IconArrowDown from '~/components/general/icons/IconArrowDown.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'TicketPriceListSM',
  props: {
    tickets: {
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['add'],
  setup: function setup(__props) {
    var props = __props;
    function mapTickets(tickets) {
      return tickets.map(function (ticket) {
        var _mappedTickets$value, _existingTicket$colla;
        var existingTicket = (_mappedTickets$value = mappedTickets.value) === null || _mappedTickets$value === void 0 ? void 0 : _mappedTickets$value.find(function (t) {
          return t.id === ticket.id;
        });
        return _objectSpread(_objectSpread({}, ticket), {}, {
          collapsed: (_existingTicket$colla = existingTicket === null || existingTicket === void 0 ? void 0 : existingTicket.collapsed) !== null && _existingTicket$colla !== void 0 ? _existingTicket$colla : true
        });
      });
    }
    var mappedTickets = ref(props.tickets.map(function (ticket) {
      return _objectSpread(_objectSpread({}, ticket), {}, {
        collapsed: true
      });
    }));
    watch(function () {
      return props.tickets;
    }, function (newValue) {
      mappedTickets.value = mapTickets(newValue);
    });
    return {
      __sfc: true,
      props: props,
      mapTickets: mapTickets,
      mappedTickets: mappedTickets,
      PPanel: PPanel,
      PButton: PButton,
      IconArrowDown: IconArrowDown
    };
  }
});